"use client";

import { useContextSelector } from "use-context-selector";
import { PreferencesStoreContext } from "./store";
import type { TooltipPreferences } from "./types";

export function useTooltipPreferences() {
    const updatePreferences = useContextSelector(PreferencesStoreContext, (s) => s?.updatePreferences);
    const tooltipsPreferences = useContextSelector(PreferencesStoreContext, (s) => s?.preferences?.accessibility?.tooltips) || {
        enabled: true,
        openOnHover: true,
        showBackground: false,
        openDelay: 500,
        animateEntryExit: true,
        animatedEntry: true,
        animatedExit: true,
    };

    const updateTooltipsPreferences = async (partial: Partial<TooltipPreferences>) => {
        await updatePreferences((prev) => ({
            ...prev,
            accessibility: { ...prev.accessibility, tooltips: { ...prev.accessibility.tooltips, ...partial } },
        }));
    };

    const replaceTooltipsPreferences = async (next: TooltipPreferences) => {
        await updatePreferences((prev) => ({
            ...prev,
            accessibility: { ...prev.accessibility, tooltips: next },
        }));
    };

    return { tooltipsPreferences, updateTooltipsPreferences, replaceTooltipsPreferences };
}



